//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconPersonSecurity(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.5 12C16.0205 12 14 14.0205 14 16.5C14 18.9795 16.0205 21 18.5 21C20.9795 21 23 18.9795 23 16.5C23 14.0205 20.9795 12 18.5 12ZM18.5 20.1C17.33 20.1 16.295 19.5375 15.638 18.6735L15.935 17.85H21.065L21.362 18.6735C20.705 19.5375 19.67 20.1 18.5 20.1ZM18.4955 13.818C19.4225 13.818 20.1785 14.574 20.1785 15.501C20.1785 16.428 19.4225 17.184 18.4955 17.184C17.5685 17.184 16.8125 16.428 16.8125 15.501C16.8125 14.574 17.5685 13.818 18.4955 13.818Z" fill="currentColor" /><path d="M21 2V9.5H19V4H5V10C5 14.6472 6.83916 17.5577 11.5 20.1123V22.3633C7.28455 20.1944 3 17.1753 3 10V2H21Z" fill="currentColor" /></svg>;
}
export default IconPersonSecurity;